// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import { Modal, TreeSelect, Affix } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import tool from '@/utils/localstorage'
import 'element-ui/lib/theme-chalk/index.css'
import './css/index.less'
import './theme/index.css'
Vue.use(ElementUI)
Vue.use(tool).use(Modal).use(TreeSelect).use(Affix)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

router.beforeEach((to, from, next) => {
  next();
});

// router.afterEach((to, from) => {
//   console.log(to, from, 'to, from, nexdvcsdt');
// });



// WEBPACK FOOTER //
// ./src/main.js